/** The code of `Drawer` (Radix Dialog, the scroll lock, focus management), fetched when it is first wanted. */
export const loadDrawer = () => import('./Drawer').then((module) => ({ default: module.Drawer }));

/**
 * Start fetching the drawer's code. Call it from the control that opens the drawer (`onPointerEnter`, `onFocus`)
 * so the sheet is there by the time the press lands.
 */
export function preloadDrawer(): void {
  void loadDrawer();
}
